import { Form, Table } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';

import { RejectedMessage, TableWrapper } from 'componets/ui';
import { SecondaryMarketOffersFilter } from './SecondaryMarketOffersFilter';

import {
	useAppSelector,
	useAppDispatch,
	useInitialSearchParams,
	useFiltersData,
	useDebouncedChange,
} from 'hooks';

import { PAGE_SIZE, RequestStatus } from 'utils/constants';

import { getSecondaryMarketItems } from 'features/secondaryMarket/actions';

import { ColumnTypes } from 'models';

import { columns } from './columns';

import s from './index.module.scss';

export const SecondaryMarketOffers = () => {
	const { items, pager, status: requestStatus } = useAppSelector((state) => state.secondaryMarket);

	const [searchParams, setSearchParams] = useSearchParams();

	const [sort, setSort] = useState();

	const searchPage = searchParams.get('page');

	const [page, setPage] = useState(1);

	useEffect(() => {
		if (searchPage) {
			setPage(+searchPage);
		}
	}, [searchPage]);

	const dispatch = useAppDispatch();

	const [form] = Form.useForm();

	const watchedValues = Form.useWatch([], form);

	const { values } = useDebouncedChange(watchedValues);
	const { initialValues } = useInitialSearchParams({ values });
	const { filtersData } = useFiltersData(initialValues);

	useEffect(() => {
		if (filtersData.minInterestRate?.endsWith('.') || filtersData.maxInterestRate?.endsWith('.')) {
			return;
		}

		dispatch(
			getSecondaryMarketItems({
				page,
				offset: (page - 1) * PAGE_SIZE,
				pageSize: PAGE_SIZE,
				sort,
				...filtersData,
			}),
		);
	}, [dispatch, page, sort, filtersData]);

	const onChange = (pagination: any, filters: any, sorter: any, current: any) => {
		const value = sorter.order
			? sorter.order === 'descend'
				? `-${sorter.field}`
				: sorter.field
			: '';

		const currentPage = current.action === 'sort' ? 1 : pagination.current;

		setSearchParams({ page: currentPage });

		if (sorter.order) {
			setSort(value);
		}
	};

	const isPending = requestStatus === RequestStatus.PENDING;

	const totalCount = pager.totalCount;

	return (
		<div className={s.root}>
			<SecondaryMarketOffersFilter form={form} initialValues={initialValues} values={values} />

			{requestStatus === RequestStatus.REJECTED ? (
				<RejectedMessage />
			) : (
				<TableWrapper data={items} loading={isPending && items.length === 0}>
					<Table
						rowKey="id"
						loading={isPending}
						onChange={onChange}
						className={`accountTable ${s.root}`}
						scroll={{ x: 1250 }}
						columns={columns as ColumnTypes}
						dataSource={items}
						showSorterTooltip={false}
						sortDirections={['ascend', 'descend', 'ascend']}
						pagination={{
							current: page,
							defaultPageSize: pager.perPage,
							total: totalCount,
							showSizeChanger: false,
							position: isMobileOnly ? ['bottomCenter'] : ['bottomRight'],
							hideOnSinglePage: true,
							showLessItems: true,
						}}
					/>
				</TableWrapper>
			)}
		</div>
	);
};
